export default [
  {
    path: "passingRecord",
    name: "passingRecord",
    component: () =>
      import("@/views/communityAccessManagement/passingRecord.vue"),
    meta: {
      title: "过人记录"
    }
  },
  {
    path: "carPassingRecord",
    name: "carPassingRecord",
    component: () =>
      import("@/views/communityAccessManagement/carPassingRecord.vue"),
    meta: {
      title: "过车记录"
    }
  }
];
